import React from 'react';
import { productName } from '../data/offer';
export function Footer() {
  return <footer className="bg-navy-950 text-navy-200" data-id="element-94" data-mp="3geze367ujv27">
      <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-95" data-mp="3ggu1qsai619z" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-96" data-mp="32onjn0nshk7w">
        <p className="font-display text-lg font-extrabold uppercase text-white" data-id="element-97" data-mp="36pft9v0kpr4p">{productName}</p>
        <p className="mt-3 text-sm" data-id="element-98" data-mp="3uf0p3ehtsive">Hecho por especialistas, para docentes de Latinoamérica.</p>
        <p className="mt-6 border-t border-navy-800 pt-6 text-xs" data-id="element-99" data-mp="3ud7ifz77pyne">
          © 2026 Megapack Gestión Ambiental Listo — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}